module.exports = __webpack_public_path__ + "img/menu-active.a24b0f8d.svg";